export default "__VITE_ASSET__d65641ff__"